import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsAuthenticated, setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSessionId = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/auth');
          return;
        }

        console.log('Processing session_id...');

        // Exchange session_id for user data
        const response = await fetch(`${BACKEND_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Important: send cookies
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || 'Authentication failed');
        }

        const userData = await response.json();
        console.log('Authentication successful:', userData);

        // Update auth context
        setIsAuthenticated(true);
        setUser({
          user_id: userData.user_id,
          email: userData.email,
          name: userData.name,
          picture: userData.picture
        });

        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true,
          state: { user: userData }
        });

      } catch (error) {
        console.error('Session exchange failed:', error);
        alert(`Erreur d'authentification: ${error.message}`);
        navigate('/auth');
      }
    };

    processSessionId();
  }, [location, navigate, setIsAuthenticated, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-black">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-400 text-lg">Authentification en cours...</p>
        <p className="text-gray-500 text-sm mt-2">Veuillez patienter</p>
      </div>
    </div>
  );
};

export default AuthCallback;
